import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid, TableHead
} from '@material-ui/core';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardActions,
    CardHeader,
    CardContent,
    Button,
    Divider,
    Table,
    TableBody,
    TableRow,
    TextField,
    TableCell,
    colors
} from '@material-ui/core';
import { get_agent, create_booking } from '../../api/API';
import moment from 'moment/moment.js';
import AddIcon from '@material-ui/icons/Add';


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3)
    },
    // pdTop: {
    //     paddingTop: '30px',
    // }
    leftIcon: {
        marginRight: theme.spacing.unit,
      },
}));

export default class Create_booking extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            agents: [],
            values: {
                agent: "",
                pax: 5
            }
        };
    }

    async get_agent(agency_id, role) {
        var data = await get_agent(
            agency_id, role
        );
        if (data) {
            this.setState({
                ...this.state,
                agents: data
            });
        }
    }

    handleChange = (event) => {

        event.persist();
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [event.target.name]: event.target.value
            }
        });
    }


    componentDidMount() {

        this.get_agent(
            window.localStorage.getItem("user_id"),
            window.localStorage.getItem("role"));

    }

    async handleSubmit(e) {
        e.preventDefault();
        console.log(this.state.values.pax);
        console.log(this.props.max_pax);
        console.log(this.state.values.pax > this.props.max_pax);
        if(parseInt(this.state.values.pax) > parseInt(this.props.max_pax)){
            alert("Exceeded maximum number of people");
            return;
        }else if(
            this.state.values.agent == ""
        ){
            alert("Please select an agent");
            return;
        }else if(
            this.state.values.pax == 0
        ){
            alert("Please specify how many people");
            return;
        }
        let data = await create_booking({
            agent_id: this.state.values.agent,
            pax: this.state.values.pax,
            timeslot_id: this.props.timeslot_id,
            date: moment(this.props.date).format("YYYY-MM-DD")
        });
        if (data.status) {
            alert("Success");
            this.props.successAction();
        } else {
            alert(data.message);
        }

    }
    render() {
        return (
            <React.Fragment>
                <Card>
                    <CardHeader title="Booking Info">
                        <TextField />
                    </CardHeader>
                    <form onSubmit={this.handleSubmit.bind(this)} >
                        <CardContent>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Agent</TableCell>
                                        <TableCell>
                                            <TextField
                                                fullWidth
                                                name="agent"
                                                select
                                                onChange={this.handleChange.bind(this)}
                                                variant="outlined"
                                                value={this.state.values.agent}
                                            >
                                                {
                                                    this.state.agents.map((agent) => (
                                                        <option
                                                            key={agent.agent_id}
                                                            value={agent.agent_id}
                                                        >
                                                            {agent.username}
                                                        </option>
                                                    ))}

                                            </TextField>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Number of people</TableCell>
                                        <TableCell>
                                            <TextField
                                                name="pax"
                                                type="number"
                                                min="0"
                                                value={this.state.values.pax}
                                                max={this.props.max_pax}
                                                placeholder={"Max :" + this.props.max_pax}
                                                onChange={this.handleChange.bind(this)}
                                            ></TextField>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </CardContent>
                        <Divider />
                        <CardActions className={this.props.classes.flexend}>
                            <Button
                                className={this.props.classes.saveButton}
                                variant="contained"
                                type="submit"
                            >
                                <AddIcon className={this.props.classes.leftIcon}/>
                                Create
                         </Button>
                        </CardActions>
                    </form>

                </Card>
            </React.Fragment>
        )
    }

} 
